import createFormJson from '../../demo/fixtures/create-form.json'
import type { Market } from '../../demo/types'
import { PickButton } from '../../ui'
import styles from './CreatePage.module.css'

interface MarketPickerProps {
  value: Market[]
  onChange: (value: Market[]) => void
}

export function MarketPicker({ value, onChange }: MarketPickerProps) {
  const toggle = (market: Market) => {
    if (value.includes(market)) {
      if (value.length > createFormJson.marketsMin) onChange(value.filter((item) => item !== market))
      return
    }
    onChange([...value, market])
  }

  return (
    <section className={styles.field} data-scope="create-market-picker">
      <div className={styles.labelRow}><span className={styles.label}>目标市场</span></div>
      <div className={styles.marketGrid}>
        {createFormJson.markets.map((item) => {
          const key = item.key as Market
          return <PickButton key={key} selected={value.includes(key)} onClick={() => toggle(key)}>{item.label}</PickButton>
        })}
      </div>
    </section>
  )
}
